import React, { useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { FormAutoB } from "../../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";
import styled from "styled-components";

export default function StaffTypePopup(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const { selectedRow, formName, setUpdateFlag } = props;
  const [data, setData] = useState(null);
  const refForm1 = useRef(null);
  const dispatch = useDispatch();
  //----------------------------------------------------------------------
  useEffect(() => {
    if (selectedRow) {
      getData(() => {
        selectedRow.action("ready");
      });
    }
  }, [selectedRow]);

  //----------------------------------------------------------------------
  const getData = (goReady) => {
    if (selectedRow && selectedRow.row && selectedRow.row.stafftypeid === 0) {
      setData(null);
      goReady();
      return;
    }
    axios
      .post(
        process.env.REACT_APP_API + "api/staff/get-staff-type",
        selectedRow.row,
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          setData(res.data.rows[0]);
          goReady();
        }
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------
  //Saving Data TO server
  const saveData = (evt) => {
    const fData1 = Object.fromEntries(new FormData(refForm1.current));

    let dataToSave = {
      ItemId: selectedRow.row["stafftypeid"],
      SaveInfo: {
        ...fData1,
        ...tmpCheckState,
      },
      UserInfo: userDetail,
    };

    /* Send data to Save */
    axios
      .post(
        process.env.REACT_APP_API + "api/staff/staff-type-upate",
        dataToSave,
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({ show: true, message: "บันทึกสมบูรณ์", type: "success" })
        );
        setWinState({ show: false });
        setUpdateFlag(true);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------
  // FIELDS Ojbect list
  const tmpCheckState = {
    flag_radi: data ? data.flag_radi : "n",
    flag_physician: data ? data.flag_physician : "n",
    flag_pacs_local: data ? data.flag_pacs_local : "n",
    brch_flag: data ? data.brch_flag : "n",
  };
  const FILEDS = [
    { label: "รหัส", oName: "stafftypecode", require: true, type: "text" },
    {
      label: "ชื่อรายการ",
      oName: "stafftypename",
      require: true,
      type: "text",
    },
    {
      label: "ชื่อแบบสั้น",
      oName: "stafftypeshort",
      require: true,
      type: "text",
    },
  ];

  const FILEDS2 = [
    {
      label: "เฉพาะรังสีแพทย์",
      oName: "flag_radi",
      require: true,
      type: "checkbox",
    },
    {
      label: "เฉพาะแพทย์เจ้าของไข้",
      oName: "flag_physician",
      require: true,
      type: "checkbox",
    },
    {
      label: "PACS สำหรับให้บริการภาพสาขา",
      oName: "flag_pacs_local",
      require: true,
      type: "checkbox",
    },
  ];

  const FILEDS3 = [
    {
      label: "อนุญาติให้ผู้ใช้ระดับสาขามองเห็น",
      oName: "brch_flag",
      require: true,
      type: "checkbox",
    },
  ];

  //----------------------------------------------------------------------
  // Return Zone
  return (
    <MyModal
      show={winState.show}
      size="lg"
      centered
      backdrop={false}
      onHide={() => {
        setWinState({ show: false });
      }}
    >
      <ModalHeaderBlack style={{ textAlign: "center" }} closeButton>
        เพิ่มแก้ไข {`${formName ? formName : "รายการ"}`}
      </ModalHeaderBlack>

      <HBox>
        <ModalBodyBlack>
          {FILEDS ? (
            <FormAutoB
              {...{
                formId: "form1",
                items: FILEDS,
                data: data,
                refTo: refForm1,
              }}
            />
          ) : null}
        </ModalBodyBlack>
      </HBox>
      <HBox>
        <VBox>
          {FILEDS ? (
            <FormAutoB
              {...{
                formId: "form2",
                items: FILEDS2,
                data: data,
                tmpCheckState: tmpCheckState,
                refTo: null,
              }}
            />
          ) : null}
        </VBox>
        <VBox>
          {FILEDS ? (
            <FormAutoB
              {...{
                formId: "form3",
                items: FILEDS3,
                data: data,
                tmpCheckState: tmpCheckState,
                refTo: null,
              }}
            />
          ) : null}
        </VBox>
      </HBox>

      <ModalFooterBlack>
        <HBox style={{ justifyContent: "right" }}>
          <Button
            style={{ marginRight: "5px" }}
            variant="primary"
            onClick={() => saveData()}
          >
            Save changes
          </Button>
          <Button variant="danger" onClick={() => setWinState({ show: false })}>
            Close
          </Button>
        </HBox>
      </ModalFooterBlack>
    </MyModal>
  );
}

const HBox = styled.div`
  flex: 1;
  display: flex;
`;

const VBox = styled.div`
  flex: 1;
  padding: 10px 20px 20px 30px;
  background-color: #1f1d1d;
`;
